// extracted by mini-css-extract-plugin
export default {"course_wrap":"course_card_course_wrap__39CBu","img_wrap":"course_card_img_wrap__WK5aV","img":"course_card_img__Ucsqh","content_wrap":"course_card_content_wrap__pNVyK"};